import { WizardStep, WizardStepIndex } from "../../../shared/enums/WizardStep";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import StepActive from "./StepActive";
import StepDone from "./StepDone";

interface MarketStepItemProps {
  activeStepIndex: number;
  market: string;
  text: string;
}

const MarketStepItem = ({
  activeStepIndex,
  market,
  text,
}: MarketStepItemProps) => {
  const stepNumber = WizardStepIndex.Market + 1;
  const hideMobile =
    activeStepIndex > WizardStepIndex.MachineTonnage ? "hideStep" : "";

  if (activeStepIndex === WizardStepIndex.Market) {
    return (
      <StepActive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  const url = linkHelper.link(WizardStep.Market, market);
  return <StepDone hideMobilClass={hideMobile} text={text} url={url} />;
};

export default MarketStepItem;
